export const userGeoLocationStoredKey = 'userGeoLocation';
